import type { AnswerValue } from '@repo/contracts/cardfinder/funnel/types';
import type { FunnelSession } from '@/entities/session/model/types';

export type FunnelSessionAction =
  | { type: 'record'; stepId: string; value: AnswerValue }
  | { type: 'complete' }
  | { type: 'startNewSession' };

export const emptyFunnelSession: FunnelSession = {
  answers: {},
  status: 'in-progress',
  sessionId: null,
  savedAs: null,
};

export function funnelSessionReducer(
  session: FunnelSession,
  action: FunnelSessionAction,
): FunnelSession {
  switch (action.type) {
    case 'record':
      return { ...session, answers: { ...session.answers, [action.stepId]: action.value } };
    case 'complete':
      return { ...session, status: 'complete' };
    case 'startNewSession':
      return { ...session, status: 'in-progress', sessionId: null, savedAs: null };
  }
}
